
module.exports = { 
      attributes: {},
    
      body: "Community health services provide comprehensive primary healthcare services to encourage good health and prevent ill health. They can help people manage their health conditions to avoid hospitalisations. They can also help people to recover from hospital treatment in their own homes.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/community-health-and-medical.md"},
     }